import { render, staticRenderFns } from "./NewPreviewTemplate.vue?vue&type=template&id=73cdac67&scoped=true"
import script from "./NewPreviewTemplate.vue?vue&type=script&lang=js"
export * from "./NewPreviewTemplate.vue?vue&type=script&lang=js"
import style0 from "./NewPreviewTemplate.vue?vue&type=style&index=0&id=73cdac67&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73cdac67",
  null
  
)

export default component.exports